import * as Pinia from "pinia";
// import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import piniaPersist from 'pinia-plugin-persist-uni'

const myPinia = Pinia.createPinia();
myPinia.use(piniaPersist);

export { Pinia, myPinia };
